'use client';

const facebookAppId = process.env.NEXT_PUBLIC_FB_APP_ID || '';
export class FacebookIntegrationManager {
  constructor() {
    this.initWindowInstance();
  }
  initWindowInstance() {
    if (typeof window === "undefined") {
      console.warn('window is not defined');
      return;
    }
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: facebookAppId,
        cookie: true,
        xfbml: true,
        version: 'v20.0',
        status: false,
        hideFlashCallback: false
      });
    };
  }
  async login() {
    return new Promise((resolve, reject) => {
      window.FB.login(function (response) {
        if (response.authResponse) {
          resolve({
            provider_token: response.authResponse.accessToken,
            provider_id: 'facebook'
          });
        } else {
          reject('User cancelled login or did not fully authorize.');
        }
      }, {
        scope: 'email,public_profile,user_birthday,user_hometown,user_location,user_gender,user_age_range',
        auth_type: 'reauthorize'
      });
    });
  }
  async logout() {
    return new Promise((resolve, reject) => {
      window.FB.logout(function (response) {
        resolve();
      });
    });
  }
  async isLogged() {
    return new Promise((resolve, reject) => {
      window.FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }
  getProfile() {
    return new Promise((resolve, reject) => {
      window.FB.api('/me', {
        fields: 'email,first_name,last_name'
      }, function (response) {
        if (response.error) {
          reject(response.error);
        } else {
          resolve({
            email: response.email,
            first_name: response.first_name,
            last_name: response.last_name
          });
        }
      });
    });
  }
}
export default new FacebookIntegrationManager();